import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

// The standalone Song Queue page was removed (ENG-315). Send any stale
// bookmarks or history entries for the old URL to the band's song list.
const SongQueueRedirect = () => {
  const { bandid } = useParams();
  return <Navigate to={`/performers/${bandid}/song-list`} replace />;
};

export default SongQueueRedirect;
